import { gateBooleanToBoolean } from "@/sg-core";

type TGateBoolean = "Y" | "N";

export interface ICommonAppConfigurations {
    aktivoitu: boolean;

    kartat: { aktivoitu: boolean };
    kehitysvalikko: boolean;
    kielet: Array<"us" | "fi">;
    kielivalikko: boolean;

    sahkopostit: {
        aktivoitu?: boolean;
        lahettaja?: { oletus?: { nimi?: string; osoite?: string } };
    };
    tekstiviestit: {
        aktivoitu?: boolean;
        lahettaja?: { oletus?: { nimi?: string } };
    };
    testi: { taustakuva?: boolean };
    url: string;
    virheviestit: boolean;

    yritys: {
        nimi?: string;
        katuosoite?: string;
    };

    kohderekisteri: any;

    hpr: {
        patevyydet: {
            syota_alkupaiva?: boolean;
        };
    };

    gate_direct_url?: string;
}

export interface ICommonAppConfigurationsDTO {
    aktivoitu: TGateBoolean;

    kartat: {
        aktivoitu: TGateBoolean;
    };
    kehitysvalikko: TGateBoolean;
    kielet: string;
    kielivalikko: TGateBoolean;
    sahkopostit?: {
        aktivoitu?: TGateBoolean;
        lahettaja?: { oletus: { nimi: string; osoite: string } };
    };
    tekstiviestit?: {
        aktivoitu?: TGateBoolean;
        lahettaja?: { oletus: { nimi: string } };
    };
    testi?: { taustakuva?: TGateBoolean };
    url: string;
    virheviestit: TGateBoolean;
    yritys?: {
        nimi?: string;
        katuosoite?: string;
    };

    lahetyspainike?: {
        sahkoposti_pohja?: string;
        tekstiviesti_pohja?: string;
        pdf_sahkopostin_liiteena?: "Y" | "N";
    };

    hpr?: {
        patevyydet?: {
            syota_alkupaiva?: TGateBoolean;
        };
    };

    kohderekisteri?: any;

    gate_direct_url?: string;
}

/**
 * Mapper primarly uses app spesific parameter and fallbacks to common parameters used in all safety applications.
 */
export const CommonAppConfigurationMapper = {
    apiToDomain: (api: ICommonAppConfigurationsDTO): ICommonAppConfigurations => {
        //   console.log("AppConfigurationMapper", { api })
        return {
            aktivoitu: gateBooleanToBoolean(api.aktivoitu),
            kartat: {
                aktivoitu: gateBooleanToBoolean(api.kartat.aktivoitu),
            },
            kehitysvalikko: gateBooleanToBoolean(api.kehitysvalikko),
            kielet: api.kielet
                .split(",")
                .filter((lang) => ["fi", "us"].includes(lang)) as ICommonAppConfigurations["kielet"],
            kielivalikko: gateBooleanToBoolean(api.kielivalikko),
            yritys: {
                nimi: api.yritys?.nimi,
                katuosoite: api.yritys?.katuosoite,
            },
            sahkopostit: {
                aktivoitu: api.sahkopostit?.aktivoitu
                    ? gateBooleanToBoolean(api.sahkopostit.aktivoitu)
                    : undefined,
                lahettaja: {
                    oletus: {
                        nimi: api.sahkopostit?.lahettaja?.oletus.nimi,
                        osoite: api.sahkopostit?.lahettaja?.oletus.osoite,
                    },
                },
            },
            tekstiviestit: {
                aktivoitu: api.tekstiviestit?.aktivoitu
                    ? gateBooleanToBoolean(api.tekstiviestit.aktivoitu)
                    : undefined,
                lahettaja: { oletus: { nimi: api.tekstiviestit?.lahettaja?.oletus.nimi } },
            },
            testi: {
                taustakuva: api.testi?.taustakuva ? gateBooleanToBoolean(api.testi.taustakuva) : undefined,
            },
            url: api.url,
            virheviestit: gateBooleanToBoolean(api.virheviestit),

            hpr: {
                patevyydet: {
                    syota_alkupaiva: api.hpr?.patevyydet?.syota_alkupaiva
                        ? gateBooleanToBoolean(api.hpr.patevyydet.syota_alkupaiva)
                        : undefined,
                },
            },

            kohderekisteri: api.kohderekisteri,

            gate_direct_url: api.gate_direct_url,
        };
    },
};
